import { render, staticRenderFns } from "./GoodsCategoryIdDetail.vue?vue&type=template&id=c49ce032&scoped=true&"
import script from "./GoodsCategoryIdDetail.vue?vue&type=script&lang=js&"
export * from "./GoodsCategoryIdDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49ce032",
  null
  
)

export default component.exports